import { DateTime } from 'luxon';
import numeral from 'numeral';
/**
 *
 * @param value Date ISO string
 * @returns Short formatted date string, Ex: Jan 02
 */
export const shortDateFormatter = (value) => {
    const isoDate = new Date(value).toISOString();
    return DateTime.fromISO(isoDate, { zone: 'utc' }).toFormat('MMM dd');
};
/**
 *
 * @param value epoch milliseconds as a string
 * @returns Long formatted date string, Ex: January 2, 2022
 */
export const dateFormatter = (value) => {
    const parsedValue = typeof value === 'string' ? +value : value;
    const isoDate = new Date(parsedValue).toISOString();
    return DateTime.fromISO(isoDate, { zone: 'utc' }).toFormat('MMMM d, yyyy');
};
export const shortNumericFormatter = (value) => numeral(value).format(`0a`);
export const stringFormatter = (value) => `${value}`;
